<template>
  <v-content>
    <v-container @keyup.enter='login' class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-container>
                <v-toolbar-title>{{ 'Learn NDT' | translate }}</v-toolbar-title>
              </v-container>
              <v-spacer />
              <v-toolbar-items>
                <v-select
                  @change="changedLanguage"
                  :value="selectedLanguage"
                  :items="languages"
                  item-value="lang_code"
                  item-text="lang_name"
                  :label="'Language' | translate "
                  outlined
                  dense
                  class="pt-3"
                  style="width:140px;"
                ></v-select>
              </v-toolbar-items>
            </v-toolbar>
            <v-container>
              <v-card-text>
                <v-row v-if="errors != 'Seats are full' && typeof errors === 'object' && Object.keys(errors).length >0">
                  <v-col cols="12" sm="12" md="12">
                    <v-alert
                      dense
                      v-for="(v, k) in errors"
                      :key="k"
                      outlined
                      type="error"
                    >{{ k }} {{ v }}</v-alert>
                  </v-col>
                </v-row>
                <v-row v-else-if="errors.length> 0 && typeof errors != 'object'">
                  <v-col cols="12" sm="8" md="8">
                    <v-alert dense outlined type="error">{{ errors }}</v-alert>
                  </v-col>
                </v-row>                
                <v-form id="form" ref="form">
                    <v-row>

                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="salutation"
                            :items="salutationvalues"
                            item-value="value"
                            item-text="name"
                            :label="'Salutation' | translate"
                            autocomplete="off"
                            name="salutation"
                            :rules="salutationRules"
                            outlined
                            required
                            :no-data-text="$t('No data available')"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                           
                          </v-select>
                        </v-col>

                        <v-col cols="9" sm="9">
                          <v-text-field
                            outlined
                            :label="'Name' | translate"
                            v-model="name"
                            name="name"
                            autocomplete="off"
                            :rules="nameRules"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                           
                          </v-text-field>
                        </v-col> 

                        <v-col cols="12" sm="12">
                          <v-text-field
                            outlined
                            :label="'Email' | translate"
                            v-model="email"
                            name="email"
                            autocomplete="off"
                            :rules="emailRules"
                            type="email"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                           
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <v-text-field
                            outlined
                            :label="'Phone number' | translate"
                            v-model="phone_no"
                            name="phone_no"
                            autocomplete="off"
                            :rules="phoneRules"
                            type="number"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                           
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            name="address"
                            v-model="address"
                            :rules="addressRules"
                            autocomplete="off"
                            :label="'Address' | translate"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template> 
                          </v-textarea>
                        </v-col>


                    </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" text @click="login">{{ 'Go to login' | translate }}</v-btn>
                <v-spacer />
                <v-btn color="primary" @click="register">{{ 'Register' | translate }}</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import Vue from "vue";
import { LOGOUT,USER_REGISTRATION,PAGES_RESET_STATE, STRIPE_RESET_STATE,FETCH_USER_REGISTRATION_STATUS, RESET_STATE } from "@/store/actions.type"
import { PURGE_AUTH,SET_LOADING,SET_SNACKBAR, SET_LOGGED_IN, SET_CUR_LANGUAGE } from "@/store/mutations.type"
import { mapState } from "vuex"
import { mapGetters } from "vuex";
import store from "@/store"
export default {
  name: "Register",
  async beforeRouteEnter(to, from, next) {
    await store.commit(SET_LOGGED_IN, false)
    await store.dispatch(STRIPE_RESET_STATE)
    await store.commit(PURGE_AUTH)
    await store.dispatch(PAGES_RESET_STATE)
    await store.dispatch(RESET_STATE)
    await store.dispatch(LOGOUT)
    await store.dispatch(FETCH_USER_REGISTRATION_STATUS, 'user').then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false);

      }
    });

    return next();
  },
  created(){
    this.changedLanguage(this.selectedLanguage)
    if(this.isAuthenticated){
      this.$router.push("/learningcenter")
    }   
    if(this.allowregistration == false){
      this.$router.push("/login")
    } 

  },  
  data() {
    return {
      name: null,
      email: null,
      phone_no: null,
      salutation: null,
      address:null,
    };
  },
  computed: {
    ...mapState({
      errors: state => state.users.usererrors,
      }),
      languages(){
        let data = [{"lang_id":1,"lang_name": this.$t("English"),"lang_code":"en"},{"lang_id":2,"lang_name": this.$t("German"),"lang_code":"de"}]
        return data
      },
      selectedLanguage(){
        return this.curLanguage !== null ? this.curLanguage.lang_code : 'de'
      },
    salutationvalues(){
      let salutationData = [
        { value: "Mr", name: this.$t("Mr") },
        { value: "Mrs", name: this.$t("Mrs") }
      ]
      return salutationData
    }, 
    nameRules(){
      return [v => !!v || "Name is required"]
    },
    phoneRules(){
      return [v => !!v || "Phone is required"]
    },
    emailRules(){
      return [v => /.+@.+/.test(v) || "Invalid Email address"]
    },
    salutationRules(){
      return [v => !!v || "Salutation is required"]
    },
    addressRules(){
      return [v => !!v || "Address is required"]
    },            


    ...mapGetters([
        "allowregistration",'curLanguage'
      ]),      
    isAuthenticated : function(){ return this.$store.getters.isAuthenticated}  
  },
  methods: {
      login(){
        this.$router.push("/login")
      },    
      async selLanguage(language) {
        await this.$store.commit(SET_CUR_LANGUAGE, language);
      },
      async changedLanguage(value) {
        Vue.i18n.set(value);
        let selectedLanguage = this.languages.find(x => value === x.lang_code);
        this.selLanguage(selectedLanguage)
      },      
      register(){
        if (this.$refs.form.validate()) {
        this.$store
          .dispatch(USER_REGISTRATION, {
            email: this.email,
            name: this.name,
            address: this.address,
            phone_no: this.phone_no,
            salutation: this.salutation,
          })
          .then(resp => {
            if (resp != undefined && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'User registeration successfully'})
              this.$store.commit(SET_LOADING, false)
              this.$router.push("/login")
            }
            else{
              this.$store.commit(SET_LOADING, false)
            }
          });
        }  
      }
   
  },
};
</script>